import UserList from 'containers/admin-user/user-list'
import UserEdit from 'containers/admin-user/user-edit'
import { PATH_ADMIN_USER_LIST, PATH_ADMIN_USER_ADD, PATH_ADMIN_USER_EDIT } from 'routing/path'

const adminRoutes = [
  { path: PATH_ADMIN_USER_LIST, component: UserList },
  { path: PATH_ADMIN_USER_ADD, component: UserEdit },
  { path: PATH_ADMIN_USER_EDIT + ":login", component: UserEdit }
]
export { adminRoutes }
